module.exports = __webpack_public_path__ + "img/circle2.22e966a0.png";